import React from "react";
import { Card, Badge, Button } from "react-bootstrap";
import { CheckCircleFill, CartFill } from "react-bootstrap-icons";
import "./CardItem.css";

const CardItem = ({ formatted_number, network, tag, sell_price }) => {


  const handleBookNow = () => {
    const message = `Hello, I'm interested in buying this premium number: *${formatted_number}*\n\nNetwork: ${network}\nPlan: ${tag}\nPrice: Rs.${sell_price}`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/94781171177?text=${encodedMessage}`, '_blank');
  };


  return (
    <>
      <Card className="shadow-lg border-0 rounded-4 hover-shadow transition-all overflow-hidden">
        <Card.Body className="p-4">
          <div className="d-flex justify-content-between align-items-start mb-3">
            <div>
              <h4 className="fw-bold mb-2 text-dark mobilenum">{formatted_number}</h4>
              <div className="d-flex gap-2">
                <Badge bg="danger" className="px-2 py-1">{network}</Badge>
                <Badge bg="warning" text="dark" className="px-2 py-1"> {tag} </Badge>
              </div>
            </div>
            <CheckCircleFill className="text-success fs-4" />
          </div>

          <div className="mb-3">
            <div className="d-flex align-items-baseline gap-2">

              <span className="fw-bold fs-4 text-danger"> Rs.{sell_price} </span>
            </div>
          </div>

          <div className="mb-4">
            <div className="d-flex align-items-center text-muted small">
              <CheckCircleFill className="text-success me-2" /> Premium {tag} service </div>
          </div>

          <Button
            onClick={handleBookNow}
            variant="danger"
            className="w-100 fw-semibold d-flex align-items-center justify-content-center py-2 rounded-3"
          >
            <CartFill className="me-2" /> Book Now
          </Button>
        </Card.Body>
      </Card>
    </>
  );
};

export default CardItem;
